import Title from "@/components/ui/title";
import S from "./index.module.scss";
import { Container } from "@/components/ui/container";
import { ETHICS } from "../../constants/ethics";
import { useTranslations } from "next-intl";

const Ethics = () => {
  const t = useTranslations("about.ethics");

  return (
    <div className={S.wrapper}>
      <Container>
        <Title variant={"black"}> {t("title")} </Title>
      </Container>
      <div className={S.borderWrap}>
        <div className={S.header}>
          <p>
            <span> {t("code")}</span> {t("principles")}
          </p>
        </div>
        <div className={S.grid}>
          {ETHICS.map((item, idx) => (
            <div className={S.item} key={idx}>
              <p> {t(item)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ethics;
